import { render, staticRenderFns } from "./ExtendedOptions.vue?vue&type=template&id=1e067c06&scoped=true&"
import script from "./ExtendedOptions.vue?vue&type=script&lang=js&"
export * from "./ExtendedOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e067c06",
  null
  
)

export default component.exports